import { useEffect, useState } from "react";
import { apiGet } from "../api/api";

export default function CampanhaForm({ faceId, onSuccess }) {
  const [marca, setMarca] = useState("");
  const [campanha, setCampanha] = useState("");
  const [obs, setObs] = useState("");
  const [foto, setFoto] = useState(null);

  const [marcasRef, setMarcasRef] = useState([]);
  const [campanhasRef, setCampanhasRef] = useState([]);
  const [marcaCampanhas, setMarcaCampanhas] = useState([]);

  // ===============================
  // Carregar referências
  // ===============================
  useEffect(() => {
    async function load() {
      setMarcasRef(await apiGet("/campanhas/marcas"));
      setCampanhasRef(await apiGet("/campanhas/nomes"));
      setMarcaCampanhas(await apiGet("/campanhas/marca-campanha"));
    }
    load();
  }, []);

  // ===============================
  // MARCAS filtradas
  // ===============================
  const marcasFiltradas = marcasRef.filter((m) =>
    m.toLowerCase().includes(marca.toLowerCase())
  );

  // ===============================
  // CAMPANHAS por MARCA (prioridade)
  // ===============================
  const campanhasPorMarca = marca
    ? marcaCampanhas
        .filter(
          (mc) =>
            mc.marca?.toLowerCase() === marca.toLowerCase() &&
            mc.campanha
              ?.toLowerCase()
              .includes(campanha.toLowerCase())
        )
        .map((mc) => mc.campanha)
    : [];

  // ===============================
  // CAMPANHAS genéricas (fallback)
  // ===============================
  const campanhasGenericas = campanhasRef.filter((c) =>
    c.toLowerCase().includes(campanha.toLowerCase())
  );

  // ===============================
  // Submeter campanha
  // ===============================
  async function registar() {
    if (!marca && !campanha) {
      alert("Preencha pelo menos Marca ou Campanha");
      return;
    }

    const form = new FormData();
    form.append("marca", marca);
    form.append("campanha", campanha);
    form.append("obs", obs);
    if (foto) form.append("file", foto);

    const res = await fetch(`/api/campanhas/face/${faceId}`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      body: form,
    });

    if (!res.ok) {
      alert(await res.text());
      return;
    }

    setMarca("");
    setCampanha("");
    setObs("");
    setFoto(null);

    alert("Campanha registada com sucesso 📸");
    onSuccess?.();
  }

  return (
    <div style={{ marginTop: 10 }}>
      <h4>📸 Registar Campanha</h4>

      {/* ===============================
          MARCA
      =============================== */}
      <label><strong>Marca</strong></label>
      <input
        placeholder="Ex: NOS, Vodafone, Continente"
        value={marca}
        onChange={(e) => setMarca(e.target.value)}
        style={{ width: "100%", padding: 10, fontSize: 16 }}
      />

      {marca && marcasFiltradas.length > 0 && (
        <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginTop: 6 }}>
          {marcasFiltradas.slice(0, 6).map((m) => (
            <button
              key={m}
              type="button"
              onClick={() => setMarca(m)}
              style={{
                padding: "5px 10px",
                borderRadius: 20,
                border: "1px solid #ccc",
                background: "#e3f2fd",
                fontSize: 14,
              }}
            >
              {m}
            </button>
          ))}
        </div>
      )}

      {/* ===============================
          CAMPANHA
      =============================== */}
      <label style={{ marginTop: 12, display: "block" }}>
        <strong>Campanha</strong>
      </label>
      <input
        placeholder="Ex: Natal 2024, Black Friday"
        value={campanha}
        onChange={(e) => setCampanha(e.target.value)}
        style={{ width: "100%", padding: 10, fontSize: 16 }}
      />

      {/* 🎯 Prioridade: campanhas da marca */}
      {campanha && campanhasPorMarca.length > 0 && (
        <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginTop: 6 }}>
          {campanhasPorMarca.slice(0, 6).map((c) => (
            <button
              key={c}
              type="button"
              onClick={() => setCampanha(c)}
              style={{
                padding: "5px 10px",
                borderRadius: 20,
                border: "1px solid #ccc",
                background: "#e8f5e9",
                fontSize: 14,
              }}
            >
              {c}
            </button>
          ))}
        </div>
      )}

      {/* 🔁 Fallback: campanhas genéricas */}
      {campanha &&
        campanhasPorMarca.length === 0 &&
        campanhasGenericas.length > 0 && (
          <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginTop: 6 }}>
            {campanhasGenericas.slice(0, 6).map((c) => (
              <button
                key={c}
                type="button"
                onClick={() => setCampanha(c)}
                style={{
                  padding: "5px 10px",
                  borderRadius: 20,
                  border: "1px solid #ccc",
                  background: "#f5f5f5",
                  fontSize: 14,
                }}
              >
                {c}
              </button>
            ))}
          </div>
        )}

      {/* ===============================
          OBS
      =============================== */}
      <input
        placeholder="Observações (opcional)"
        value={obs}
        onChange={(e) => setObs(e.target.value)}
        style={{ width: "100%", padding: 10, marginTop: 12 }}
      />

      {/* ===============================
          FOTO
      =============================== */}
      <input
        type="file"
        onChange={(e) => setFoto(e.target.files[0])}
        style={{ marginTop: 10 }}
      />

      {/* ===============================
          SUBMIT
      =============================== */}
      <button
        onClick={registar}
        style={{
          background: "#2e7d32",
          color: "white",
          padding: "12px",
          marginTop: 12,
          width: "100%",
          fontSize: 18,
          border: "none",
          borderRadius: 6,
        }}
      >
        📸 Guardar Campanha
      </button>
    </div>
  );
}
